import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertService, PartnerListService } from '../_services';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { AwardToRewardListService } from '../_services/award-to-reward-list.service';
import { AwardToRewardService } from '../_services/award-to-reward.service';
@Component({
  selector: 'app-award-to-reward-partner-list',
  templateUrl: './award-to-reward-partner-list.component.html',
  styleUrls: []
})
export class AwardToRewardPartnerListComponent implements OnInit {

  bodyDataArr:any=[]
  headDataArr:any=[]
  dtOptions: DataTables.Settings = {};
  dtTrigger = new Subject();
  atrList: any[] = [];
  closeResult: string;
  selectedStatus:any

  constructor(
              public router: Router,
              private dataService:AwardToRewardListService,
              private alertService: AlertService,
              private modalService: NgbModal,
              private atrService :AwardToRewardService
            ) { }

  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.allAtrList();
  }

  viewResponse(slug){
    this.router.navigate(['atr-response/' + slug]);

  }

  allAtrList(){
    this.loadShow();
      this.dataService.getAllAwardToReward().subscribe((res:any)=>{
      console.log(res.data,"ttttt");
      this.atrList = res.data
      this.dtTrigger.next(); // Data Table  
      this.loadHide();
      })
     }

  openPartnerViewPage(id) {
    this.router.navigate(['atr-view-list/' + id]);
  }

  updateStatus(item){

  }

  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

  delete(id){
    this.loadShow()
    if(confirm("Are you sure to delete")) {
      this.dataService.deleteAwardToReward(id)
          .pipe().subscribe(data =>{            
            if(data['status']==200){
              this.dtTrigger = new Subject(); //  DataTable
              this.alertService.success('Atr deleted successfully', true);
              this.allAtrList();
              this.loadShow()
            }else{
              this.alertService.error('ATR error');
            }
          },error =>{
            this.alertService.error(error);
          });
       }
  }

}
